export const EVENT_DISPLAY = {
    // Property
    'property.created': { label: 'Property Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'property.updated': { label: 'Property Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    'property.status_approved': { label: 'Property Approved', icon: 'bi-check-circle', badgeClass: 'bg-success' },
    'property.status_denied': { label: 'Property Denied', icon: 'bi-x-circle', badgeClass: 'bg-danger', reasonClass: 'text-danger' },
    // Claim
    'claim.approved': { label: 'Claim Approved', icon: 'bi-person-check', badgeClass: 'bg-success' },
    'claim.owner-assigned': { label: 'Owner Assigned', icon: 'bi-person-plus', badgeClass: 'bg-success' },
    'claim.denied': { label: 'Claim Denied', icon: 'bi-person-x', badgeClass: 'bg-danger', reasonClass: 'text-danger', showChanges: false },
    // Change Request
    'change-request.created': { label: 'Change Request Submitted', icon: 'bi-file-earmark-plus', badgeClass: 'bg-info text-dark', showChanges: false },
    'change-request.approved': { label: 'Change Request Approved', icon: 'bi-file-earmark-check', badgeClass: 'bg-success', showChanges: false },
    'change-request.denied': { label: 'Change Request Denied', icon: 'bi-file-earmark-x', badgeClass: 'bg-danger', reasonClass: 'text-danger', showChanges: false },
    // Community Event
    'event.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'event.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    // Announcement
    'announcement.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'announcement.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    // Banner
    'banner.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'banner.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    'banner.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    // Director
    'director.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'director.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    'director.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    // Discussion
    'discussion.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'discussion.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    'discussion.status_changed': { label: 'Status Changed', icon: 'bi-arrow-repeat', badgeClass: 'bg-info text-dark' },
    'discussion.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    'discussion.comment_created': { label: 'Comment Added', icon: 'bi-chat-dots', badgeClass: 'bg-info text-dark', showChanges: false },
    'discussion.comment_deleted': { label: 'Comment Removed', icon: 'bi-chat-dots', badgeClass: 'bg-danger', showChanges: false },
    'discussion.access_requested': { label: 'Access Requested', icon: 'bi-key', badgeClass: 'bg-warning text-dark', showChanges: false },
    // Discussion Kind
    'discussion-kind.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success', showChanges: false },
    'discussion-kind.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary', showChanges: false },
    'discussion-kind.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    // FAQ
    'faq.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'faq.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    'faq.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    // Form
    'form.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    'form.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary' },
    'form.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    // Parcel Kind
    'parcel-kind.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success', showChanges: false },
    'parcel-kind.updated': { label: 'Updated', icon: 'bi-pencil', badgeClass: 'bg-primary', showChanges: false },
    'parcel-kind.deleted': { label: 'Deleted', icon: 'bi-trash', badgeClass: 'bg-danger', showChanges: false },
    // Parcel
    'parcel.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success' },
    // Role
    'role.created': { label: 'Created', icon: 'bi-plus-circle', badgeClass: 'bg-success', showChanges: false },
    // User
    'user.registered': { label: 'Registered', icon: 'bi-person-plus', badgeClass: 'bg-success', showChanges: false },
    'user.profile_updated': { label: 'Profile Updated', icon: 'bi-person-gear', badgeClass: 'bg-primary', showChanges: false },
    'user.profile_deleted': { label: 'Account Deleted', icon: 'bi-person-x', badgeClass: 'bg-danger', showChanges: false },
    'user.roles_updated': { label: 'Roles Updated', icon: 'bi-shield-check', badgeClass: 'bg-info text-dark', showChanges: false },
    // District
    'district.about_updated': { label: 'About Updated', icon: 'bi-pencil', badgeClass: 'bg-primary', showChanges: false },
    'district.home_updated': { label: 'Home Updated', icon: 'bi-house', badgeClass: 'bg-primary', showChanges: false },
    'district.logo_updated': { label: 'Logo Updated', icon: 'bi-image', badgeClass: 'bg-primary', showChanges: false },
    'district.title_updated': { label: 'Title Updated', icon: 'bi-pencil', badgeClass: 'bg-primary', showChanges: false },
    'district.area_geometry_updated': { label: 'Geometry Updated', icon: 'bi-geo-alt', badgeClass: 'bg-primary', showChanges: false },
    'district.theme_updated': { label: 'Theme Updated', icon: 'bi-palette', badgeClass: 'bg-primary', showChanges: false },
    'district.award_created': { label: 'Award Created', icon: 'bi-trophy', badgeClass: 'bg-success', showChanges: false },
    'district.award_updated': { label: 'Award Updated', icon: 'bi-trophy', badgeClass: 'bg-primary', showChanges: false },
    'district.award_deleted': { label: 'Award Deleted', icon: 'bi-trophy', badgeClass: 'bg-danger', showChanges: false },
    'district.ad_created': { label: 'Ad Created', icon: 'bi-megaphone', badgeClass: 'bg-success', showChanges: false },
    'district.ad_updated': { label: 'Ad Updated', icon: 'bi-megaphone', badgeClass: 'bg-primary', showChanges: false },
    'district.ad_deleted': { label: 'Ad Deleted', icon: 'bi-megaphone', badgeClass: 'bg-danger', showChanges: false },
    // Moderation
    'moderation.status_updated': { label: 'Status Updated', icon: 'bi-shield-exclamation', badgeClass: 'bg-warning text-dark', showChanges: false },
    'moderation.dismissed': { label: 'Dismissed', icon: 'bi-shield-check', badgeClass: 'bg-secondary', showChanges: false },
    'moderation.removed': { label: 'Content Removed', icon: 'bi-shield-x', badgeClass: 'bg-danger', showChanges: false },
    'moderation.flag_created': { label: 'Flag Created', icon: 'bi-flag', badgeClass: 'bg-warning text-dark', showChanges: false },
    'moderation.bad_word_created': { label: 'Bad Word Added', icon: 'bi-plus-circle', badgeClass: 'bg-warning text-dark', showChanges: false },
    'moderation.bad_word_deleted': { label: 'Bad Word Removed', icon: 'bi-trash', badgeClass: 'bg-secondary', showChanges: false },
    'moderation.ip_block_created': { label: 'IP Blocked', icon: 'bi-shield-lock', badgeClass: 'bg-danger', showChanges: false },
    'moderation.ip_block_deleted': { label: 'IP Unblocked', icon: 'bi-shield-check', badgeClass: 'bg-secondary', showChanges: false },
    'moderation.user_kind_access_updated': { label: 'User Access Updated', icon: 'bi-person-lock', badgeClass: 'bg-info text-dark', showChanges: false },
    'moderation.role_kind_access_updated': { label: 'Role Access Updated', icon: 'bi-shield-lock', badgeClass: 'bg-info text-dark', showChanges: false },
    'moderation.user_blocked': { label: 'User Blocked', icon: 'bi-person-slash', badgeClass: 'bg-danger', showChanges: false },
    // Admin
    'admin_rewind': { label: 'Reverted', icon: 'bi-arrow-counterclockwise', badgeClass: 'bg-warning text-dark', reasonClass: 'text-warning', showChanges: false, staticDetail: 'Reverted to a previous version' },
};
export const FIELD_LABELS = {
    title: 'Title',
    overview: 'Overview',
    owner_details: 'Owner Details',
    established: 'Established',
    status_name: 'Status',
    status_title: 'Status',
    parcel_id: 'Parcel',
    updated_at: 'Updated',
    approved_at: 'Approved',
    denied_at: 'Denied',
    denial_reason: 'Denial Reason',
    description: 'Description',
    location: 'Location',
    starts_at: 'Starts At',
    ends_at: 'Ends At',
    event_type: 'Event Type',
    event_status: 'Event Status',
    body: 'Body',
    synopsis: 'Synopsis',
    kind: 'Kind',
    published: 'Published',
    is_pinned: 'Pinned',
    display_name: 'Display Name',
    first_name: 'First Name',
    last_name: 'Last Name',
    sort_order: 'Sort Order',
    is_public: 'Public',
    display: 'Display Name',
};
const IGNORED_FIELDS = new Set(['id', 'created_at', 'tenant_id', 'area_id']);
const formatLabel = (key) => FIELD_LABELS[key] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
export const getChangedFields = (beforeJson, afterJson) => {
    var _a, _b;
    if (!beforeJson || !afterJson)
        return [];
    try {
        const before = JSON.parse(beforeJson);
        const after = JSON.parse(afterJson);
        const allKeys = Array.from(new Set([...Object.keys(before), ...Object.keys(after)]));
        const changes = [];
        for (const key of allKeys) {
            if (IGNORED_FIELDS.has(key))
                continue;
            const bVal = String((_a = before[key]) !== null && _a !== void 0 ? _a : '');
            const aVal = String((_b = after[key]) !== null && _b !== void 0 ? _b : '');
            if (bVal !== aVal)
                changes.push({ field: key, label: formatLabel(key), before: bVal, after: aVal });
        }
        return changes;
    }
    catch (_c) {
        return [];
    }
};
